import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';

const SettingToggle = ({ 
  label, 
  description, 
  checked, 
  onChange, 
  disabled = false,
  className = '' 
}) => {
  return (
    <div className={`flex items-start justify-between py-3 ${className}`}>
      <div className="flex-1 min-w-0 pr-4">
        <label className="text-sm font-medium text-text-primary cursor-pointer">
          {label}
        </label>
        {description && (
          <p className="text-xs text-text-secondary mt-1">{description}</p>
        )}
      </div>
      <div className="flex-shrink-0">
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e?.target?.checked)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default SettingToggle;